/**
 * Common Helmet page with a basic seo meta tags.
 * @param id google tag manager id.
 * @param fireCustomEvent function to push event.
 */

const GoogleAnalytics: React.FC<{ id: string; fireCustomEvent: (eventName: string, url: string) => void }> = ({
  id,
  fireCustomEvent,
}) => {
  const customEvent = fireCustomEvent.toString();

  return (
    <>
      <script src={`https://www.googletagmanager.com/gtag/js?id=${id}`} />
      <script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){${customEvent};}
          gtag('js', new Date());
          
           const user_id = '*_ze_id';

           function find_or_create_user_id() {
            const user_id = localStorage.getItem(user_id);
            if (!user_id) {
              localStorage.setItem(user_id, Math.random().toString(36).substring(2, 15));
            }
            return user_id;
          }

          const ze_id = find_or_create_user_id();

          gtag('config', '${id}', {
            link_id: ze_id,
            page_path: window.location.pathname,
            first_field_name: 'application', 
            linker: {
               domains: ['docs.zephyr-cloud.io', 'zephyr-cloud.io', 'app.zephyr-cloud.io']
            }
          });

          gtag('set', 'linker', {
            accept_incoming: true,
          });
        `}
      </script>
    </>
  );
};

export { GoogleAnalytics };
